import { render, staticRenderFns } from "./WelcomeTextExtensive.vue?vue&type=template&id=7a81fe76&"
import script from "./WelcomeTextExtensive.vue?vue&type=script&lang=js&"
export * from "./WelcomeTextExtensive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports